var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Catalog",
    _vm._g(
      {
        attrs: {
          title: "Вид работ",
          "name-label": "Название вида работ",
          "description-label":
            "Будет отображаться в объекте, заявках и при выставлении счёта",
          "submit-error": "Укажите название вида работ.",
          "fetch-data": _vm.fetchData,
          "put-data": _vm.putData,
          "post-data": _vm.postData,
          "exact-id": _vm.createId
        },
        scopedSlots: _vm._u([
          {
            key: "optional-skeleton",
            fn: function() {
              return [
                _c(
                  "b-row",
                  { staticClass: "mb-2" },
                  [
                    _c(
                      "b-col",
                      [
                        _c("b-skeleton", {
                          staticClass: "mb-2",
                          attrs: { width: "32%", height: "16%" }
                        }),
                        _vm._v(" "),
                        _c("b-skeleton", {
                          staticClass: "mb-2",
                          attrs: { type: "input", width: "100%", height: "30%" }
                        }),
                        _vm._v(" "),
                        _c("b-skeleton", {
                          staticClass: "mb-0",
                          attrs: { width: "50%", height: "15%" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "optional-fields",
            fn: function(ref) {
              var model = ref.model
              return [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      id: "group-vacancy",
                      label: "Название вакансии",
                      "label-for": "input-vacancy",
                      description: "Будет отображаться у исполнителя"
                    }
                  },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: "input-name",
                        type: "text",
                        size: "sm",
                        trim: ""
                      },
                      model: {
                        value: model.vacancy,
                        callback: function($$v) {
                          _vm.$set(model, "vacancy", $$v)
                        },
                        expression: "model.vacancy"
                      }
                    })
                  ],
                  1
                )
              ]
            }
          }
        ])
      },
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d98d0ff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d98d0ff","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/WorkType/WorkTypeCatalog.vue
// module id = null
// module chunks = 